import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { get } from "lodash";

const MixpanelUserTracker = () => {
    const { isAuthenticated, user } = useAuth0();

    useEffect(() => {
        // Only proceed if we have a valid user object with required properties
        if (isAuthenticated && user?.sub) {
            try {
                const mixpanel = get(window, "mixpanel");
                if (!mixpanel) {
                    console.error("Mixpanel not available for user identification");
                    return;
                }

                // Identify the user
                const identify = get(mixpanel, "identify");
                if (typeof identify === "function") {
                    identify.call(mixpanel, user.sub);
                }

                // Set user properties if people tracking is available
                const peopleSet = get(mixpanel, "people.set");
                if (typeof peopleSet === "function") {
                    try {
                        peopleSet.call(mixpanel.people, {
                            $name: user.name || "Anonymous",
                            $email: user.email || "",
                            last_login: new Date().toISOString(),
                            auth0_id: user.sub,
                            nickname: user.nickname || "",
                            picture: user.picture || "",
                            platform: "web",
                            version: "1.0.0",
                        });
                    } catch (error) {
                        console.error("Error setting Mixpanel user properties:", error);
                    }
                }

                // Track login event after identification
                const track = get(mixpanel, "track");
                if (typeof track === "function") {
                    track.call(mixpanel, "User Login", {
                        user_id: user.sub,
                        email: user.email || "",
                        platform: "web",
                        version: "1.0.0",
                    });
                }

                // Force send any queued events
                const flush = get(mixpanel, "flush");
                if (typeof flush === "function") {
                    flush.call(mixpanel);
                }
            } catch (error) {
                console.error("Mixpanel identification error:", error);
            }
        } else if (!isAuthenticated) {
            try {
                const mixpanel = get(window, "mixpanel");
                if (!mixpanel) return;

                // Reset Mixpanel when user logs out
                const reset = get(mixpanel, "reset");
                if (typeof reset === "function") {
                    reset.call(mixpanel);
                }

                // Force send any queued events before reset
                const flush = get(mixpanel, "flush");
                if (typeof flush === "function") {
                    flush.call(mixpanel);
                }
            } catch (error) {
                console.error("Mixpanel reset error:", error);
            }
        }
    }, [isAuthenticated, user]);

    return null; // This component doesn't render anything
};

export default MixpanelUserTracker;
